import { render, staticRenderFns } from "./CreateSections.vue?vue&type=template&id=39b1590a&scoped=true&"
import script from "./CreateSections.vue?vue&type=script&lang=js&"
export * from "./CreateSections.vue?vue&type=script&lang=js&"
import style0 from "./CreateSections.vue?vue&type=style&index=0&id=39b1590a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1590a",
  null
  
)

component.options.__file = "CreateSections.vue"
export default component.exports